module.exports = __webpack_public_path__ + "Group@2x.896cf366.png";


//////////////////
// WEBPACK FOOTER
// ./src/template/Modals/RegisterUser/images/Group@2x.png
// module id = 68Kf
// module chunks = 0